// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestion-row {
  display: flex;
  gap: 14px;
  overflow-x: auto;
  padding: 10px 2px 20px;
  scroll-snap-type: x mandatory;
}

.suggestion-row::-webkit-scrollbar {
  height: 6px;
}

.suggestion-row::-webkit-scrollbar-thumb {
  background: #e5e7eb;
  border-radius: 10px;
}

.toast {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--primary-200);
  color: white;
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: fadeInDown 0.3s ease;
  z-index: 9999;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/componentsL/matching/SuggestionRow.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;;EAEA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF","sourcesContent":[".suggestion-row {\n  display: flex;\n  gap: 14px;\n  overflow-x: auto;\n  padding: 10px 2px 20px;\n  scroll-snap-type: x mandatory;\n}\n\n.suggestion-row::-webkit-scrollbar {\n  height: 6px;\n}\n\n.suggestion-row::-webkit-scrollbar-thumb {\n  background: #e5e7eb;\n  border-radius: 10px;\n}\n\n.toast {\n  position: fixed;\n  top: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--primary-200);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 12px;\n  font-size: 14px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  animation: fadeInDown 0.3s ease;\n  z-index: 9999;\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translate(-50%, 20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
